import { CodeHighlight } from '@mantine/code-highlight'
import {
  Box,
  Text,
} from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { CollapsibleCard } from '@flecto/ui'

import { useSnippetStore } from '../../hooks/useSnippetStore'
import { FormImages } from '../FormStoreSettings/FormImages'
import { FormSection } from '../FormStoreSettings/FormSection'
import styles from './styles.module.css'

export function CardStoreIframe() {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_store' })

  const { snippetHeightAuto, snippetHeightManual } = useSnippetStore()

  return (
    <FormSection>
      <CollapsibleCard opened className={styles.iframe}>
        <CollapsibleCard.Title>
          {t('section_iframe.title')}
        </CollapsibleCard.Title>
        <CollapsibleCard.Description>
          <Box mr='sm'>{t('section_iframe.description')}</Box>
        </CollapsibleCard.Description>
        <CollapsibleCard.Content>
          <Text fw={500} mt='sm' mb='sm'>
            {t('section_iframe.iframe_height_manual_title')}
          </Text>
          <CodeHighlight
            code={snippetHeightManual}
            language='html'
          />

          <Text fw={500} mt='lg' mb='sm'>
            {t('section_iframe.iframe_height_auto_title')}
          </Text>
          <CodeHighlight
            code={snippetHeightAuto}
            language='js'
          />
        </CollapsibleCard.Content>
      </CollapsibleCard>
      <FormImages images={[require('./image.jpeg')]} />
    </FormSection>
  )
}
